export const BankAccountInputType = Object.freeze({
  PRINCIPAL: 'principal',
  IBAN: 'iban',
  SELECT: 'select'
})
